<template>
  <div class="py-32">
    <h3 class="heading-3">
      {{ i18n(translations.needHelp) }}
    </h3>
    <div v-if="faqUrl">
      <FormattedMessage
        class="body-1 mt-12"
        :definition="translations.cantAccessDashboardGetHelp"
        tag="p"
      >
        <template #link>
          <RevLink target="_blank" :to="FAQ_TABLEAU_URL">
            {{ i18n(translations.getHelp) }}
          </RevLink>
        </template>
      </FormattedMessage>

      <FormattedMessage
        class="body-1 mt-12"
        :definition="translations.howToReadDashboardLearnHow"
        tag="p"
      >
        <template #link>
          <RevLink target="_blank" :to="faqUrl">
            {{ i18n(translations.learnHow) }}
          </RevLink>
        </template>
      </FormattedMessage>
    </div>

    <FormattedMessage
      v-else
      class="body-1 mt-12"
      :definition="translations.cannotAccessDescription"
      tag="p"
    >
      <template #link>
        <RevLink target="_blank" :to="CANNOT_ACCES_LINK_URL" underlined>
          {{ i18n(translations.cannotAccessCTA) }}
        </RevLink>
      </template>
    </FormattedMessage>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { toBcp47Locale } from '@backmarket/utils/string/toBcp47Locale'
import { RevLink } from '@ds/components/Link'

import {
  CANNOT_ACCES_LINK_URL,
  FAQ_ARTICLE_LINKS,
  FAQ_TABLEAU_URL,
} from './Help.constants'
import translations from './Help.translations'

const i18n = useI18n()
const props = defineProps<{ currentTab?: string }>()

const faqUrl = computed(() => {
  const link = props.currentTab && FAQ_ARTICLE_LINKS[props.currentTab]
  const locale = toBcp47Locale(i18n.currentLocale)

  return link ? link[locale] || link.default : ''
})
</script>
